import {
  ADDITIONAL_DEPENDENT_PROPERTIES,
  attachCustomsInfoSelector,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  LABEL_PROPERTY_SEND_EU_PRODUCT_IDENTIFIERS,
  updateLabelConfig,
  VALID_SEND_EU_PRODUCT_IDENTIFIERS_SHIPPER_TYPES,
} from '../../../data/labelInfos/index.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {getState, useSelector} from '../../../store.js'

const SEND_EU_PRODUCT_IDENTIFIERS_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return SEND_EU_PRODUCT_IDENTIFIERS_DEPENDENT_PROPERTIES
}

export function sendEUProductIdentifiersLabelPropertiesFunc(
  shipperType,
  labelInfoID,
) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo ? [LABEL_PROPERTY_SEND_EU_PRODUCT_IDENTIFIERS] : []
}

export default function SendEUProductIdentifiers() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = SendEUProductIdentifiers.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigCheckbox
      label="Send EU Product Identifiers"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={!attachCustomsInfo}
    />
  )
}

SendEUProductIdentifiers.propertySpecList = [
  {
    validShipperTypes: VALID_SEND_EU_PRODUCT_IDENTIFIERS_SHIPPER_TYPES,
    labelPropertiesFunc: sendEUProductIdentifiersLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return [LABEL_PROPERTY_SEND_EU_PRODUCT_IDENTIFIERS]
    },
  },
]
